webpackJsonp([35783957827783],{

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _kickAssBiscuits = __webpack_require__(133);
	
	var _kickAssBiscuits2 = _interopRequireDefault(_kickAssBiscuits);
	
	var _chickenBiscuitMug = __webpack_require__(61);
	
	var _chickenBiscuitMug2 = _interopRequireDefault(_chickenBiscuitMug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Messaging = function Messaging() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'center',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Open for ',
	        _react2.default.createElement(
	          'a',
	          { href: _config2.default.userLinks[4].url, target: '_blank' },
	          'Takeout'
	        ),
	        ' and ',
	        _react2.default.createElement(
	          'a',
	          { href: _config2.default.userLinks[10].url, target: '_blank' },
	          'Delivery'
	        ),
	        _react2.default.createElement('br', null),
	        'or ',
	        _react2.default.createElement(
	          'a',
	          { href: _config2.default.userLinks[6].url, target: '_blank' },
	          'Order Gift Cards'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          { href: 'https://honest-biscuits.square.site/#gfTNzW' },
	          'Order Easy Gift Boxes and support small businesses in Seattle'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'd-md-inline-flex row align-items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col text-center mx-auto' },
	        _react2.default.createElement('img', { className: 'img-fluid', src: _kickAssBiscuits2.default, alt: 'Kick Ass Biscuits' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col text-center mx-auto' },
	        _react2.default.createElement('img', {
	          className: 'img-fluid page-image',
	          src: _chickenBiscuitMug2.default,
	          alt: 'Chicken Biscuit Mug'
	        })
	      )
	    )
	  );
	};
	
	exports.default = Messaging;
	module.exports = exports['default'];

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/chicken-biscuit-mug.36f5ce9c.jpg";

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kick-ass-biscuits.49bee86c.png";

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _messaging = __webpack_require__(84);
	
	var _messaging2 = _interopRequireDefault(_messaging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(_messaging2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ae8acf60528b913a3645.js